/**
 * Teaser Slider animation.
 */
export const initTeaserSliderAnimation = () => {
    document.querySelectorAll('.c-teaser-slider.active').forEach(teaserSlider => {
        const slides = teaserSlider.querySelectorAll('.slide');
        const indicators = teaserSlider.querySelectorAll('.slider-pagination > div');
        const next = teaserSlider.querySelector('.slider-next');
        const prev = teaserSlider.querySelector('.slider-prev');

        if (!slides || !indicators || !next || !prev) return;

        const slidesCount = slides.length;
        let currentSlide = 0;
        let timer;

        /**
         * Set the active slide by its index.
         *
         * @param index
         */
        const setActiveSlide = index => {
            slides.forEach(slide => slide.classList.remove('active'));
            slides[index].classList.add('active');
        };

        /**
         * Set the active indicator by its index.
         *
         * @param index
         */
        const setActiveIndicator = index => {
            indicators.forEach(indicator => indicator.classList.remove('active'));
            indicators[index].classList.add('active');
        };

        // Add click listeners to indicators.
        indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => animateToSlide(index, true));
        });

        /**
         * Animate to a slide by its index.
         *
         * @param index
         * @param resetInterval
         */
        const animateToSlide = (index, resetInterval) => {
            if (index === 'next') {
                currentSlide = currentSlide < slidesCount - 1 ? currentSlide + 1 : 0;
            } else if (index === 'prev') {
                currentSlide = currentSlide > 0 ? currentSlide - 1 : slidesCount - 1;
            } else {
                currentSlide = index;
            }

            setActiveSlide(currentSlide);
            setActiveIndicator(currentSlide);
            fixTeaserSliderHeight(teaserSlider, slides[currentSlide]);

            if (resetInterval) {
                clearInterval(timer);

                timer = setInterval(() => animateToSlide('next'), 7000);
            }
        };

        // Add click listeners to next and prev chevrons.
        next.addEventListener('click', () => animateToSlide('next', true), { passive: true });
        prev.addEventListener('click', () => animateToSlide('prev'), { passive: true });

        let touchstartX = 0;
        let touchendX = 0;

        const handleGesture = () => {
            if (touchendX < touchstartX) animateToSlide('next', true);
            if (touchendX > touchstartX) animateToSlide('prev', true);
        };

        teaserSlider.addEventListener('touchstart', event => (touchstartX = event.changedTouches[0].screenX), {
            passive: true,
        });

        teaserSlider.addEventListener(
            'touchend',
            event => {
                touchendX = event.changedTouches[0].screenX;
                handleGesture();
            },
            { passive: true }
        );

        // Animate to first slide on init.
        animateToSlide(currentSlide);

        // Set the animation timer on init.
        timer = setInterval(() => animateToSlide('next'), 7000);
    });
};

const fixTeaserSliderHeight = (teaserSlider, currentSlide) => {
    const picture = currentSlide.querySelector('.picture');
    const content = currentSlide.querySelector('.content');

    if (!picture || !content) return;

    const height = window.innerWidth > 1023 ? 'auto' : picture.scrollHeight + content.scrollHeight + 'px';
    teaserSlider.style.setProperty('height', height);
};

export const fixTeaserSliderHeightOnResize = () => {
    document.querySelectorAll('.c-teaser-slider.active').forEach(teaserSlider => {
        fixTeaserSliderHeight(teaserSlider, teaserSlider.querySelector('.slide.active'));
    });
};
